<template>
  <input v-bind="$attrs" :value="displayValue" class="form-control" @input="onInput" @change="$emit('change', displayValue)" />
</template>
<script lang="ts">
import { computed, defineComponent } from 'vue'
export default defineComponent({
  name: 'BFormInput',
  inheritAttrs: false,
  props: { modelValue: { default: undefined }, value: { default: undefined }, trim: Boolean },
  emits: ['update:modelValue', 'input', 'change'],
  setup(props, { emit }) {
    const displayValue = computed(() => props.modelValue ?? props.value ?? '')
    const onInput = (event: Event) => {
      const input = event.target as HTMLInputElement
      const value = props.trim ? input.value.trim() : input.value
      emit('update:modelValue', value)
      emit('input', value)
    }
    return { displayValue, onInput }
  }
})
</script>
